"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var UICardHero = _styledComponents.default.div.withConfig({
  displayName: "UICardHero",
  componentId: "u86g6g-0"
})(_templateObject());

UICardHero.displayName = 'UICardHero';
var _default = UICardHero;
exports.default = _default;
module.exports = exports.default;